// Server-Sent Events from POST /api/v1/coo/chat/threads/{id}/messages: turn, delta, tool, block (NomOS) and done.
import type { CooChatEvent } from '@/types'

const EVENTS = new Set(['turn', 'delta', 'tool', 'block', 'done'])

/** A chat request the API refused (non-2xx): `code` is the API's machine code, e.g. coo_unavailable. */
export class CooChatError extends Error {
  constructor(public status: number, public code: string, message: string) {
    super(message)
    this.name = 'CooChatError'
  }
}

/** Split a buffer into complete events and the incomplete rest. Comments, unknown events and bad JSON are skipped. */
export function parseSseBuffer(buffer: string): { events: CooChatEvent[]; rest: string } {
  const blocks = buffer.replace(/\r\n/g, '\n').split('\n\n')
  const rest = blocks.pop() ?? ''
  const events: CooChatEvent[] = []
  for (const block of blocks) {
    let name = ''
    const data: string[] = []
    for (const line of block.split('\n')) {
      if (line.startsWith(':')) continue
      if (line.startsWith('event:')) name = line.slice(6).trim()
      else if (line.startsWith('data:')) data.push(line.slice(5).trimStart())
    }
    if (!EVENTS.has(name) || data.length === 0) continue
    try {
      events.push({ event: name, data: JSON.parse(data.join('\n')) } as CooChatEvent)
    } catch {
      // A malformed event is dropped; the stored answer is fetched when the turn ends.
    }
  }
  return { events, rest }
}
